export const nusConstant = {
    LOGIN_USING_GUEST_ACCOUNT_REQUEST: 'LOGIN_USING_GUEST_ACCOUNT_REQUEST',
    LOGIN_USING_GUEST_ACCOUNT_SUCCESS: 'LOGIN_USING_GUEST_ACCOUNT_SUCCESS',
    LOGIN_USING_GUEST_ACCOUNT_FAILURE: 'LOGIN_USING_GUEST_ACCOUNT_FAILURE'
 };